import React from 'react';
import ServiceUnderConstruction from '../../components/ServiceUnderConstruction';
import logo from '../../assets/images/services/imolink.webp';

const Imolink = () => {
    return (
        <ServiceUnderConstruction
            serviceKey="imolink"
            logo={logo}
            primaryColor="#2C3E50"
            secondaryColor="#34495E"
        />
    );
};

export default Imolink;
